import _Circle from "@kibt/meta-ui/es/circle";
import _Loading from "@kibt/meta-ui/es/loading";
import _Toast from "@kibt/meta-ui/es/toast";
import { defineComponent, computed, ref, watch } from '@vue/composition-api';
import { lrpx2px } from '@/utils/device';
export default defineComponent({
  components: {
    MToast: _Toast,
    MLoading: _Loading,
    MCircle: _Circle
  },
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    value: {
      type: Number,
      default: 0
    },
    // 为什么
    speed: {
      type: Number,
      default: 1
    }
  },
  emits: ['update'],
  setup: function setup(props, ctx) {
    var computedPercent = computed({
      get: function get() {
        return props.value;
      },
      set: function set(val) {}
    });
    var currentPercent = ref(props.value);

    var doAnimate = function doAnimate() {
      if (currentPercent.value < props.value) {
        currentPercent.value = props.speed + currentPercent.value;
        window.requestAnimationFrame(doAnimate);
      }
    };

    watch(function () {
      return props.value;
    }, function () {
      window.requestAnimationFrame(doAnimate);
    });
    return {
      computedPercent: computedPercent,
      currentPercent: currentPercent,
      lrpx2px: lrpx2px
    };
  }
});